module.exports = __webpack_public_path__ + "static/commission_orange.1f6277e0.svg";